<template>
  <v-container fluid class="my-5">
    <div class="d-flex justify-space-between align-center flex-wrap mb-4">
      <div><h2 class="subheading grey--text">Áreas de oficina</h2><p class="grey--text text--darken-1 mb-0">Configura las áreas que reciben y clasifican las invitaciones de oficina.</p></div>
      <v-btn color="primary" @click="openDialog()"><v-icon left>mdi-plus</v-icon>Nueva área</v-btn>
    </div>
    <v-card class="elevation-2">
      <v-data-table :headers="headers" :items="areas" :no-data-text="'No hay áreas registradas'">
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-3" @click="editArea(item)">mdi-pencil</v-icon>
          <v-icon small @click="openDeleteDialog(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="540">
      <v-form @submit.prevent="saveArea()"><v-card>
        <v-toolbar dark color="primary"><v-toolbar-title>{{ editing ? 'Editar área' : 'Nueva área' }}</v-toolbar-title><v-spacer></v-spacer><v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn></v-toolbar>
        <v-card-text class="pt-5">
          <v-text-field v-model="area.name" label="Nombre del área" outlined required></v-text-field>
          <v-text-field v-model="area.description" label="Descripción" outlined></v-text-field>
        </v-card-text>
        <v-card-actions><v-btn text color="primary" @click="dialog = false">Cancelar</v-btn><v-spacer></v-spacer><v-btn color="primary" type="submit">Guardar</v-btn></v-card-actions>
      </v-card></v-form>
    </v-dialog>
    <v-dialog v-model="dialogDelete" persistent max-width="400">
      <v-card>
        <v-toolbar dark color="error">
          <v-toolbar-title>Eliminar área</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogDelete = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <p>¿Estás seguro de que deseas eliminar esta área?</p>
          <p class="caption grey--text">Esta acción no se puede deshacer.</p>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" @click="dialogDelete = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="confirmDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import employeeService from '@/services/employeeService'

export default {
  name: 'oficina_areas',
  data () {
    return {
      areas: [],
      dialog: false,
      dialogDelete: false,
      editing: false,
      editingId: null,
      deletingId: null,
      loading: false,
      area: this.emptyArea(),
      headers: [
        { text: 'Área', value: 'name' },
        { text: 'Descripción', value: 'description' },
        { text: 'Acciones', value: 'actions', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters(['getProfile']),
    housingUnitId () {
      return this.getProfile.idHousingUnit
    }
  },
  mounted () {
    this.loadAreas()
  },
  watch: {
    housingUnitId (newVal) {
      if (newVal) {
        this.loadAreas()
      }
    }
  },
  methods: {
    async loadAreas () {
      if (!this.housingUnitId) {
        console.error('Housing unit ID not available')
        return
      }
      this.loading = true
      try {
        const areasData = await employeeService.getAreas(this.housingUnitId)
        this.areas = areasData.results || areasData
      } catch (error) {
        console.error('Error loading areas:', error)
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', 'Error al cargar áreas')
        this.$store.commit('snackbar_activate_true')
      } finally {
        this.loading = false
      }
    },
    emptyArea () {
      return {
        name: '',
        description: ''
      }
    },
    openDialog () {
      this.editing = false
      this.editingId = null
      this.area = this.emptyArea()
      this.dialog = true
    },
    editArea (item) {
      this.editing = true
      this.editingId = item.id
      this.area = { ...item }
      this.dialog = true
    },
    async saveArea () {
      if (!this.area.name) return
      try {
        this.loading = true
        if (this.editing) {
          await employeeService.updateArea(this.editingId, {
            name: this.area.name,
            description: this.area.description
          })
          this.$store.commit('snackbar_change_message', 'Área actualizada correctamente')
        } else {
          await employeeService.createArea(this.housingUnitId, {
            name: this.area.name,
            description: this.area.description
          })
          this.$store.commit('snackbar_change_message', 'Área creada correctamente')
        }
        this.$store.commit('snackbar_change_color', 'success')
        this.$store.commit('snackbar_activate_true')
        this.dialog = false
        await this.loadAreas()
      } catch (error) {
        console.error('Error saving area:', error)
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', (error.response && error.response.data && error.response.data.detail) || 'Error al guardar área')
        this.$store.commit('snackbar_activate_true')
      } finally {
        this.loading = false
      }
    },
    openDeleteDialog (item) {
      this.deletingId = item.id
      this.dialogDelete = true
    },
    async confirmDelete () {
      try {
        this.loading = true
        await employeeService.deleteArea(this.deletingId)
        this.$store.commit('snackbar_change_color', 'success')
        this.$store.commit('snackbar_change_message', 'Área eliminada correctamente')
        this.$store.commit('snackbar_activate_true')
        this.dialogDelete = false
        await this.loadAreas()
      } catch (error) {
        console.error('Error deleting area:', error)
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', 'Error al eliminar área')
        this.$store.commit('snackbar_activate_true')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
